const identity = (x) => x;
const always = () => true;
const never = () => false;
export {
  always,
  identity,
  never
};
